import { render, staticRenderFns } from "./UserManagementIndex.vue?vue&type=template&id=dd6b34ce"
import script from "./UserManagementIndex.vue?vue&type=script&lang=js"
export * from "./UserManagementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports